import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../App';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft } from '@phosphor-icons/react';

const PaymentCancel = () => {
  const { t, language } = useAuth();

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="payment-cancel">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center max-w-md"
      >
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-amber-50 flex items-center justify-center">
          <XCircle size={48} weight="fill" className="text-amber-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          {language === 'de' ? 'Zahlung abgebrochen' : 'Payment Cancelled'}
        </h1>
        
        <p className="text-slate-500 mb-8">
          {language === 'de' 
            ? 'Ihre Zahlung wurde abgebrochen. Keine Gebühren wurden erhoben.'
            : 'Your payment was cancelled. No charges have been made.'}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/book" className="btn-primary flex items-center justify-center gap-2">
            <ArrowLeft size={18} />
            {language === 'de' ? 'Zurück zur Buchung' : 'Back to Booking'}
          </Link>
          <Link to="/dashboard" className="btn-secondary">
            {t('dashboard')}
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default PaymentCancel;
